<script setup>
import { useApi } from '@/utils/api'
import { useApiRequest } from '@/composables/useApiRequest'

definePage({
  meta: {
    layout: 'default',
    action: 'create',
    subject: 'Supplier',
  },
})

const router = useRouter()
const { loading, errors, request } = useApiRequest()

const form = ref({
  name: '',
  contact_person: '',
  phone: '',
  email: '',
  address: '',
  is_active: true,
})

const submit = async () => {
  // useApiRequest handles loading, errors (422), dan error lainnya
  const result = await request(() =>
    useApi('/api/v1/suppliers').post({ body: form.value })
  )

  if (result !== null) {
    // result = body langsung dari ofetch (sudah di-parse)
    router.push({ name: 'purchase-suppliers' })
  }
}
</script>

<template>
  <VRow>
    <VCol cols="12" md="8" lg="6">
      <VCard>
        <VCardTitle class="pt-5 px-5">Tambah Supplier</VCardTitle>

        <VDivider />

        <VCardText class="pa-5">
          <!-- General error -->
          <VAlert
            v-if="errors._general"
            type="error"
            variant="tonal"
            class="mb-4"
          >
            {{ errors._general[0] }}
          </VAlert>

          <VRow>
            <VCol cols="12">
              <VTextField
                v-model="form.name"
                label="Nama Supplier *"
                :error-messages="errors.name"
              />
            </VCol>

            <VCol cols="12" md="6">
              <VTextField
                v-model="form.contact_person"
                label="Contact Person"
                :error-messages="errors.contact_person"
              />
            </VCol>

            <VCol cols="12" md="6">
              <VTextField
                v-model="form.phone"
                label="Telepon"
                :error-messages="errors.phone"
              />
            </VCol>

            <VCol cols="12" md="6">
              <VTextField
                v-model="form.email"
                label="Email"
                type="email"
                :error-messages="errors.email"
              />
            </VCol>

            <VCol cols="12" md="6" class="d-flex align-center">
              <VSwitch
                v-model="form.is_active"
                label="Supplier Aktif"
                color="success"
                hide-details
              />
            </VCol>

            <VCol cols="12">
              <VTextarea
                v-model="form.address"
                label="Alamat"
                rows="3"
                :error-messages="errors.address"
              />
            </VCol>
          </VRow>
        </VCardText>

        <VDivider />

        <VCardActions class="pa-5">
          <VSpacer />
          <VBtn
            variant="tonal"
            :to="{ name: 'purchase-suppliers' }"
          >
            Batal
          </VBtn>
          <VBtn
            color="primary"
            :loading="loading"
            @click="submit"
          >
            Simpan
          </VBtn>
        </VCardActions>
      </VCard>
    </VCol>
  </VRow>
</template>
